import React from 'react'
import Sidebar from './Sidebar'
const ManageUsersContainer = () => {
  return (
    <div className='mt-3'>
        <Sidebar />
    </div>
  )
}

export default ManageUsersContainer